import Vue from 'vue';
import getLiveRoomInfo from '@/utils/liveRoomInfo';
import { addParam } from '@/utils/util';
import { openPageAction, yoda, showToast, openHalfWebview } from '@/utils/yoda';
import openOrDownload from '@/utils/openOrDownload';
import {isInApp} from '@/utils/env';
import {versionCompareFunc, pageRatio} from '@/pages/global-midyear/config';
import {getStorage} from '@/utils/storage';
// import kwailog from '@/utils/kibtLogger';

export interface RankStatusMap {
    ALL: number;
    PRE: number;
    OPPOSE: number;
    FINAL: number;
  }

export type TCheckFunc<Status> = (...status: Status[]) => boolean;

export const isStatusIncludes = <Status>(current: Status, ...list: Status[]) => list.includes(current);

// 打开新页面
export async function withInfoRouteTo(url: string, params?:Record<string, unknown>, locationAction = false) {
    const { query, liveAuthorId } = getLiveRoomInfo();
    // 在端外不进行页面打开
    if (!isInApp){
        openOrDownload(window.location.href);
        return;
    }
    const logParamsStr = getStorage('logParams');

    const logParams = logParamsStr ? JSON.parse(logParamsStr) : {};
    if (params){
        const newParams = {
            ...params,
            source: query.source || '',
            isLiving: query.isLiving,
            authorId: liveAuthorId,
            hyId: query.hyId,
            liveWHRatio: pageRatio,
            ...logParams,
        };
        openPageAction(addParam(url, newParams), locationAction);
    } else {
        openPageAction(addParam(url, {
            ...logParams,
            ...query,
        }), locationAction);
    }
};

export const ensureResult = <T extends { result: number }, V, P extends Array<V>>(requester: (...args: P) => Promise<T>) => {
    return async (...args: P) => {
        const res = await requester(...args);

        if (res.result !== 1) {
            throw new Error('result code not expected');
        }

        return res;
    };
};
const { isLiving, isAuthorSelf, query } = getLiveRoomInfo();
// 点击送礼按钮
export const goSendGift = (obj?:{ tab?:number, giftId?:number}) => {

    if (!isInApp) {
        openOrDownload(window.location.href);
        return;
    }
    if (isLiving) {

        yoda.ready().then(() => {
            yoda.component.backOrCloseWeb({ closeWeb: true });
            if (!obj){
                yoda.component.openLiveGiftPanel();
            } else {
                const url = addParam('kwaiLive://giftPanel', obj);
                yoda.live.startLiveInnerRouter({ url });
            }
        }).catch(() => {
            showToast(Vue.prototype.$k18n({ id: 'common/network_error' }), 'normal');
        });
    } else {
        window.location.href = 'ikwai://live/slide';
    }
};

// 点击PK按钮
export const goPk = () => {
    let url = '';
    if (!isInApp){
        openOrDownload(window.location.href);
        return;
    }
    if (isLiving){
        // 在直播间
        // 判断版本
        if (versionCompareFunc('7.2.10')){
            url = 'kwaiLive://PK?tab=0';
            yoda.ready().then(()=>{
                yoda.live.startLiveInnerRouter({ url });
                yoda.component.backOrCloseWeb({ closeWeb: true });
            });

        } else {
            showToast(window?.__$k18n({ id: 'k_336722' }) || 'network err', 'normal');
        }
    } else {
        // 不在直播间
        // 去开播
        url = 'ikwai://post?tab=live';
        window.location.href = url;
    }
};
// 生成埋点的默认参数
export const getLogerCommonParams = () => {
    const params = {
        user_type: isAuthorSelf ? '1' : '0',
    };
    return Promise.resolve(params);
};

// 计算比赛进程
export const getMatchProgress = (rankStatusMap:RankStatusMap) => {
    let competitionsStatus = 0;
    if (rankStatusMap.PRE === 1 || rankStatusMap.PRE === 103){
        competitionsStatus = 0;
    } else if (rankStatusMap.OPPOSE === 1 || rankStatusMap.OPPOSE === 103){
        competitionsStatus = 1;
    } else if (rankStatusMap.FINAL === 1 || rankStatusMap.FINAL === 103){
        competitionsStatus = 2;
    } else if (rankStatusMap.ALL === 103){
        competitionsStatus = 0;
    } else {
        competitionsStatus = 2;
    }
    return competitionsStatus;
};

// 直播间弹窗查看详情逻辑
export const clickDetail = (url?:string) => {
    yoda.ready().then(() => {
        // 关闭页面
        yoda.component.backOrCloseWeb({ closeWeb: true });
        if (url){
            const params = {
                ...query,
                liveWHRatio: 0.62,
            };
            // 打开新半屏
            openHalfWebview(url, params, {
                launchType: 1,
                corner: 16,
                height: pageRatio,
                fullScreen: '0',
                hideToolbar: true,
                enableProgress: true, // 安卓
            });
        }
    });
};

// 弹窗样式
export const getTextHtml = (val:string|number) => {
    return `
    <span class="ye-txt">【${val}】</span>
    `;
};
